import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ValidTimeSettingRoutingModule } from './valid-time-setting-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ValidTimeSettingRoutingModule
  ]
})
export class ValidTimeSettingModule { }
